import React from "react";

function Icon(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 510 510"
      version="1.1"
      viewBox="0 0 510 510"
      xmlSpace="preserve"
      {...props}
    >
      <path
        fill="currentColor"
        d="M2495 4466c-16-8-438-423-937-923-986-987-931-926-913-1020 6-34 108-139 923-955 997-997 935-941 1029-923 49 9 109 69 118 118 18 94 66 39-848 955l-842 842 842 843c747 747 842 846 848 880 24 133-101 237-220 183z"
        transform="matrix(.1 0 0 -.1 0 512)"
      ></path>
      <path
        fill="currentColor"
        d="M4255 4466c-16-8-438-423-937-923-986-987-931-926-913-1020 6-34 108-139 923-955 997-997 935-941 1029-923 49 9 109 69 118 118 18 94 66 39-848 955l-842 842 842 843c747 747 842 846 848 880 24 133-101 237-220 183z"
        transform="matrix(.1 0 0 -.1 0 512)"
      ></path>
    </svg>
  );
}

export default Icon;
